exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-fade-enter-active[data-v-3fe27130],.slide-fade-leave-active[data-v-3fe27130]{transition:all .5s ease}.slide-fade-leave-active[data-v-3fe27130]{transition:all .3s ease}.slide-fade-enter[data-v-3fe27130],.slide-fade-leave-to[data-v-3fe27130]{opacity:0;transform:translateY(-10px)}", ""]);

// exports
